import React from "react";
import { colors } from "../common/styles/colors";
import { Dimensions, View } from "react-native";
import ReactLoading from "react-loading";

export const CommonLoading = () => (
  <View
    style={{
      backgroundColor: colors.black,
      height: Dimensions.get("window").height,
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <ReactLoading width="25%" color={colors.LightGrayishYellow} />
  </View>
);
